document.addEventListener("DOMContentLoaded", function() {
    const botones = document.querySelectorAll(".control-boton");
    const imagenesContenedor = document.querySelectorAll(".imagen-contenedor");

    if (botones.length === 0 || imagenesContenedor.length === 0) {
        console.error("❌ No se encontraron botones o imágenes. Revisa las clases en HTML.");
        return;
    }

    botones.forEach((boton, index) => {
        boton.addEventListener("click", function() {
            // Ocultar todas las imágenes
            imagenesContenedor.forEach(img => img.style.display = "none");

            // Mostrar la imagen correspondiente al botón clicado
            const targetId = boton.getAttribute("data-target");
            const imagenSeleccionada = document.getElementById(targetId);

            if (imagenSeleccionada) {
                imagenSeleccionada.style.display = "block";
            } else {
                console.error(`⚠️ No se encontró la imagen con ID: ${targetId}`);
            }

            // Resaltar el botón activo
            botones.forEach(btn => btn.classList.remove("activo"));
            boton.classList.add("activo");
        });
    });

    // Mostrar la primera imagen por defecto
    if (imagenesContenedor[0]) {
        imagenesContenedor.forEach(img => img.style.display = "none");
        imagenesContenedor[0].style.display = "block";
    }
});